export default __webpack_public_path__ + "static/media/profile.42148e87.png";